/**
 * Functional programming helper pipe (reduce functions L -> R)
 */
const pipe = (fn1, fn2) => (val) => fn2(fn1(val));

export default pipe;



// WEBPACK FOOTER //
// ./app/utils/fpHelpers/pipe.js